import { format } from 'date-fns';
import * as yup from 'yup';
import { isMoment, Moment } from 'moment';
import DOMPurify from 'dompurify';
import { DECIMAL_SCALE } from 'config';

export const DATE_FORMAT = 'dd/MM/yyyy';

const emailRegex =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
const phoneNumberRegex =
  // eslint-disable-next-line no-useless-escape
  /^(([0-9]{6,20})|([\+]?[(]?(([2-9][0-9])|([2-8][0-9][0-9]))[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}))$/;
const phoneNumberMax = 20;
const emailMax = 100;

export const formatDate = (date: Date | Moment) =>
  typeof date !== 'undefined' && format(isMoment(date) ? date.toDate() : date, DATE_FORMAT);

export const phoneNumberSchema = (excludeEmptyString = true) =>
  yup
    .string()
    .matches(phoneNumberRegex, { excludeEmptyString, message: 'Please enter a valid phone number' })
    .max(phoneNumberMax);

export const emailSchema = ({ excludeEmptyString = true, required = true }) => {
  const schema = yup
    .string()
    .matches(emailRegex, { excludeEmptyString, message: 'Please enter a valid email address' })
    .max(emailMax);

  return required ? schema.required('Please enter a valid email address') : schema;
};

export const isObjectContainsXss = (obj: object) =>
  Object.values(obj).some(
    (value) => typeof value === 'string' && value !== DOMPurify.sanitize(value, { ALLOWED_TAGS: [] })
  );

export const toNumber = (value: string | number | null) => {
  if (value === null) {
    return null;
  }

  return (typeof value === 'string' ? Number(value.replace(/,/g, '')) : value).toFixed(DECIMAL_SCALE);
};

export const toExpenseArray = (obj: object) =>
  Object.entries(obj).map(([key, value]) => ({
    expense_type: key,
    expense_amount_per_month: toNumber(value),
  }));
